







import { Component, Vue } from "vue-property-decorator";

@Component
export default class HeaderLogin extends Vue {
  constructor() {
    super();
  }
}
